import * as actionTypes from '../constants/actionTypes';

export const showErrorModal = (message: string) => (dispatch: any) => dispatch({
  type: actionTypes.SHOW_ERROR_MODAL,
  payload: {
    message,
  },
});

export default showErrorModal;
